module.exports = __webpack_public_path__ + "img/bb-logo.07d5e558.svg";